export const PAGINATION_FIRST_PAGE = 1;
export const PAGINATION_DEFAULT_LAST_PAGE = 1;
export const PAGINATION_DEFAULT_TOTAL = 0;
export const PAGINATION_DEFAULT_PER_PAGE = 15;
export const PAGINATION_NO_NEXT_PAGE = -1;
export const PAGINATION_PER_PAGE_OPTIONS = [15, 30, 50, 100];
